import { render, staticRenderFns } from "./OrderRecipientFields.vue?vue&type=template&id=284753ff&"
import script from "./OrderRecipientFields.vue?vue&type=script&lang=js&"
export * from "./OrderRecipientFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports